<script>
//医院的base url 用来识别localstage item，每家不同，必须设置，不用带http

 //const hosUrl='zxskyk.glhis.com';
 //const hosName='镇雄视康眼科医院';

 //const hosUrl='cxgkyy.glhis.com';
 //const hosName='楚雄骨科医院';

// const hosUrl='cxyyzyyy.glhis.com';
// const hosName='楚雄義延中医医院';

// const hosUrl='wxxcawsy.glhis.com';
// const hosName='威信县长安卫生院';

// const hosUrl='wxxmgwsy.glhis.com';
// const hosName='威信县庙沟卫生院';

// const hosUrl='cxjkyy.glhis.com';
// const hosName='楚雄经开医院';

// const hosUrl='wxxjcwzxsy.glhis.com';
// const hosName='威信县旧城中心卫生院';

// const hosUrl='cxrzzxyjhyy.glhis.com';
// const hosName='楚雄仁泽中西医结合医院';

// const hosUrl='wxzxhsyy.glhis.com';
// const hosName='威信扎西华晟医院';

// const hosUrl='cxskjsbyy.glhis.com';
// const hosName='楚雄神康精神病医院';

// const hosUrl='lcxfybjjhsyfwzx.glhis.com';
// const hosName='绿春县妇幼保健计划生育服务中心';

// const hosUrl='wxxshwsy.glhis.com';
// const hosName='威信县双河卫生院';

// const hosUrl='dyakjszkyy.glhis.com';
// const hosName='大姚安康精神专科医院';

// const hosUrl='cxbayy.glhis.com';
// const hosName='楚雄博爱医院';

// const hosUrl='cxldzzygsyy.glhis.com';
// const hosName='楚雄刘德章中医骨伤医院';

// const hosUrl='cxlkyy.glhis.com';
// const hosName='楚雄历康医院';

// const hosUrl='wxrayy.glhis.com';
// const hosName='威信仁安医院';

// const hosUrl='lfbdfcyy.glhis.com';
// const hosName='禄丰北大妇产医院';

// const hosUrl='cxrhjkyy.glhis.com';
// const hosName='楚雄仁合济康医院';

// const hosUrl='stwsy.glhis.com';
// const hosName='威信县三桃卫生院';

const hosUrl='wxxstwsy.glhis.com';
const hosName = '威信县水田卫生院';

// const hosUrl='wxxlfzxwsy.glhis.com';
// const hosName='威信县麟凤中心卫生院';

// const hosUrl='tcsmykyy.glhis.com';
// const hosName='腾冲视明眼科医院';

// const hosUrl='wxxxzyyy.glhis.com';
// const hosName='威信新欣中医医院';

// const hosUrl = 'cxhylnbzkyy.glhis.com';
// const hosName = '楚雄海亚老年病专科医院';

// const hosUrl = 'wxklyy.glhis.com';
// const hosName = '威信康立医院';

// const hosUrl = "wxxgtwsy.glhis.com";
// const hosName = "威信县高田卫生院";

//const hosUrl = "lfygyy.glhis.com";
//const hosName = "禄丰阳光医院";

//const hosUrl = "wxxlbzxwsy.glhis.com";
//const hosName = "威信县罗布中心卫生院";

//const hosUrl = "lcxfybjy.glhis.com";
// const hosName = "绿春县妇幼保健院";

 // const hosUrl = "wxbxyy.glhis.com";
 // const hosName = "威信百姓医院";

export default {
  hosName,
  hosUrl,
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue